import React from 'react';
import MaterialDrawer from '@mui/material/Drawer';

import type {DrawerProps as MaterialDrawerProps} from '@mui/material/Drawer';

export interface DrawerProps extends Omit<MaterialDrawerProps, 'anchor'> {
    /**
     * Set anchor position
     */
    position?: MaterialDrawerProps['anchor'];
}

export const Drawer = React.forwardRef<any, DrawerProps>(({
    position = 'left', children, ...props
}, ref): React.ReactElement => (
    <MaterialDrawer
        anchor={position}
        ref={ref}
        {...props}
    >
        {children}
    </MaterialDrawer>
));

Drawer.displayName = 'Drawer';
